import { BaseService } from './base-service';
import {
	CreateCalculationReturnOfInvestmentsRequestDTO,
	UpdateCalculationReturnOfInvestmentsRequestDTO,
	CreateCalculationReturnOfInvestmentsResponseDTO,
	UpdateCalculationReturnOfInvestmentsResponseDTO,
	GetCalculationReturnOfInvestmentsResultRequestDTO,
	GetCalculationReturnOfInvestmentsResultResponseDTO
} from '@/core/dto/calculation-return-of-investments';

export class CalculationReturnOfInvestmentsService extends BaseService {
	private static instance: CalculationReturnOfInvestmentsService;

	private constructor(public readonly basePath: string = '/calculation-return-of-investments') {
		super();
	}

	public static getInstance(): CalculationReturnOfInvestmentsService {
		if (!CalculationReturnOfInvestmentsService.instance) {
			CalculationReturnOfInvestmentsService.instance = new CalculationReturnOfInvestmentsService();
		}
		return CalculationReturnOfInvestmentsService.instance;
	}

	public async create(
		params: CreateCalculationReturnOfInvestmentsRequestDTO
	): Promise<CreateCalculationReturnOfInvestmentsResponseDTO> {
		const url = this.basePath;
		const { data } = await this.getInstance().post<CreateCalculationReturnOfInvestmentsResponseDTO>(url, params);
		return data;
	}

	public async update(
		params: UpdateCalculationReturnOfInvestmentsRequestDTO
	): Promise<UpdateCalculationReturnOfInvestmentsResponseDTO> {
		const url = `${this.basePath}/${params.id}`;
		const { data } = await this.getInstance().put<UpdateCalculationReturnOfInvestmentsResponseDTO>(url, params);
		return data;
	}

	public async getResult(
		params: GetCalculationReturnOfInvestmentsResultRequestDTO
	): Promise<GetCalculationReturnOfInvestmentsResultResponseDTO> {
		const url = `${this.basePath}/${params.id}/result`;
		const { data } = await this.getInstance().get<GetCalculationReturnOfInvestmentsResultResponseDTO>(url);
		return data;
	}
}
